import { SvgIcon, SvgIconProps } from '@mui/material'

const ErrorMarkIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path
        d="M10 5.83334C10.4583 5.83334 10.8333 6.20834 10.8333 6.66667V10C10.8333 10.4583 10.4583 10.8333 10 10.8333C9.54167 10.8333 9.16667 10.4583 9.16667 10V6.66667C9.16667 6.20834 9.54167 5.83334 10 5.83334ZM9.99167 1.66667C5.39167 1.66667 1.66667 5.40001 1.66667 10C1.66667 14.6 5.39167 18.3333 9.99167 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.40001 14.6 1.66667 9.99167 1.66667ZM10 16.6667C6.31667 16.6667 3.33333 13.6833 3.33333 10C3.33333 6.31667 6.31667 3.33334 10 3.33334C13.6833 3.33334 16.6667 6.31667 16.6667 10C16.6667 13.6833 13.6833 16.6667 10 16.6667ZM10.8333 14.1667H9.16667V12.5H10.8333V14.1667Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ErrorMarkIcon
